"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.testResults.title': '测试结果',
    'botTest.testResults.results': '条结果',
    'botTest.testResults.result': '结果',
    'botTest.testResults.metrics': '指标',
    'botTest.testResults.totalMessages': '总消息数',
    'botTest.testResults.totalTokens': '总令牌数',
    'botTest.testResults.totalCost': '总费用',
    'botTest.testResults.executionTime': '执行时间',
    'botTest.testResults.averageResponseTime': '平均问题完成时间',
    'botTest.testResults.inputTokens': '输入令牌',
    'botTest.testResults.outputTokens': '输出令牌',
    'botTest.testResults.messageCount': '消息',
    'botTest.testResults.error': '错误',
    'botTest.testResults.response': 'AI 回复',
    'botTest.testResults.questionGeneration': '问题生成',
    'botTest.testResults.success': '成功',
    'botTest.testResults.tokens': '令牌',
    'botTest.testResults.cost': '费用',
    'botTest.testResults.status.pending': '待处理',
    'botTest.testResults.status.running': '运行中',
    'botTest.testResults.status.completed': '已完成',
    'botTest.testResults.status.failed': '失败',
    'botTest.testResults.questionsAndAnswers': '问题与答案',
    'botTest.testResults.question': '问题',
    'botTest.testResults.questionLabel': '问',
    'botTest.testResults.answerLabel': '答',
    'botTest.testResults.answerStartTime': '响应时间（首个令牌）',
    'botTest.testResults.no_results': '暂无测试结果',
    'botTest.testResults.no_results_description': '运行测试以在此查看结果。',
};
